import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getOrganizationResourcesFeedQueryV2,
  getChildResourcesFeedQueryV2,
  getLELibraryFeedQuery,
} from "./LeFeedQuery";
import { FILTER_NAME_POST_TYPE } from "Teacher/routes/Courses/routes/Course/Constants/StringConstants";
import { ENABLE_MULTI_LE_IMPORT } from "Constants/permissionConstants";
import ACLStore from "lib/aclStore";

export const getOrganizationResourcesV2FromCache = ({
  parentId,
  parentType,
  searchText,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationResourcesFeedQueryV2,
      variables: { parentId, parentType, searchText },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getChildResourcesFromCacheV2 = ({
  id,
  first,
  after,
  orderBy,
  orderByDirection,
  filters,
}) => {
  let queryData = {};

  try {
    queryData = queryData = client.readQuery({
      query: getChildResourcesFeedQueryV2,
      variables: { id, first, after, filters, orderBy, orderByDirection },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getLEFilters = ({
  filters,
  options,
  key,
  defaultPostType = [],
}) => {
  const filtersCopy = _.cloneDeep(filters);
  _.forEach(options, optionItem => {
    const filterData = filtersCopy[optionItem[key]];
    const filterOptions = _.map(optionItem.options, "value");
    const leFeedFiltersPostSize = _.size(filtersCopy[FILTER_NAME_POST_TYPE]);

    if (_.size(filterData) === _.size(filterOptions)) {
      filtersCopy[optionItem[key]] = [];
    }

    if (leFeedFiltersPostSize == 0) {
      filtersCopy[FILTER_NAME_POST_TYPE] = defaultPostType;
    }
  });
  return filtersCopy;
};

export const getLELibraryFeedFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLELibraryFeedQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  return queryData != null ? queryData : {};
};

export const isMultiLeImportEnabled = () =>
  ACLStore.can(ENABLE_MULTI_LE_IMPORT);
